import PurchaseBusinessService from '../../purchase-business-service';
import Service from '@/service/index.js';
import Pagination from '@/components/pagination/index.vue';
import {contracteProjectStatus} from '@/utils/mixins/contracte-project-status';
import { changeSkin } from '@/utils/common.js';
import { successMessage, errorMessage } from '@/utils/message.js';
import QrCodePage from '@/components/qr-code/index.vue';
import updateBankMixins from '@/utils/mixins/update-bank-mixins.js';
export default {
  mixins: [updateBankMixins, contracteProjectStatus],
  components: {
    Pagination,
    QrCodePage
  },
  data() {
    return {
      currentProjectId: '',
      projectStatusArr: [],
      projectTypeArr: [],
      total: 0,
      currentPage: 1,
      pageSize: 5,
      tableList: [],
      goSignData: {
        name: '',
        mobile: ''
      },
      qrCodeVisible: false,
      projectId: ''
    };
  },
  created() {
    const arr = [
      ['projectStatusArr', 'PURCHASE_STATUS'], ['projectTypeArr', 'PURCHASE_PROJECT_TYPE']
    ];
    arr.forEach((value) => {
      if (!value.length) {
        return;
      }
      Service.getSelectList(value[1]).then(res => {
        if (res && res.code === '0') {
          this[value[0]] = res.data;
        }
      });
    });
    this.getContractingProjectList();
  },
  computed: {
  },
  filters: {
    toFixed: function (value) {
      if (!value) return '';
      return ((value)/10000).toFixed(2);
    }
  },
  methods: {
    changeSkin,
    // 收不到签约短信
    qrCodeClick(projectId) {
      this.projectId = projectId;
      this.qrCodeVisible = true;
    },
    // 获取承包采购项目列表
    getContractingProjectList(page){
      if (page) {
        this.currentPage = page.pageNo;
        this.pageSize = page.pageSize;
      }
      PurchaseBusinessService.getContractingProjectList({
        pageNum: this.currentPage,
        pageSize: this.pageSize
      }).then(res => {
        if (res && res.code === '0') {
          this.total = res.data.total;
          this.tableList = res.data.list;
        }
      });
    },
    // 左侧bn展示
    getProjectType (type) {
      if (type === 1) {
        return require('@/assets/images/common/engineering1.jpg');
      } else if (type === 2) {
        return require('@/assets/images/common/goods1.jpg');
      } else {
        return require('@/assets/images/common/service1.jpg');
      }
    },
    // 申请签署合同
    goSign (item) {
      // let params = new FormData();
      // params.append('purchaseId', item.purchaseId);
      PurchaseBusinessService.postSign(item.purchaseId).then(res => {
        if(res.code === '0'){
          let msg = '已向'+ res.data.name +'的'+ res.data.mobile +'手机号发送邀请签约短信，请及时确认';
          successMessage(msg);
        }else{
          errorMessage(res.reason);
        }
      });
    },
    downloadConfirm (item){
      PurchaseBusinessService.downloadContract(item.purchaseId).then(res => {
        if(res.code === '0'){
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = 'data:file/doc;base64,' + res.data.contractUrl;
          link.download = ('农村集体采购项目合同.doc');
          document.body.appendChild(link);
          link.click();
          window.URL.revokeObjectURL(link.href);
        }else{
          errorMessage(res.reason);
        }
      });
    },
    // 确认成交书
    supplerConfirm (item) {
      this.$router.push('/person-center/purchase-business/contracting-project/contracting-contract-list?id=' + item.purchaseId);
    },
    // 跳转详情
    goToDetail (item) {
      console.log(item, 'item的val');
      window.open(window.location.origin + '/#/collective-purchasing/detail?id=' + item.purchaseId);
      // this.$router.push('/collective-purchasing/detail?id=' + item.purchaseId);
    },
    // 查看项目文件
    goFileImage (item) {
      console.log(item);
      this.$router.push('/person-center/purchase-business/contracting-project/file-list?id=' + item.purchaseId);
    },

    payProjectDeposit(item) {
      this.$router.push('/person-center/purchase-business/contracting-project/contracting-pay-list?id=' + item.purchaseId + '&transactionType=12');
    }
  }
};
